module.exports = __webpack_public_path__ + "img/notification-play.e94c51c7.svg";